import React, { useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import BusinessExpansionHeroSection from './BusinessExpansionHeroSection';
import BusinessExpansionBusinessSection from './BusinessExpansionBusinessSection';
import CommercialVehicleEmiSection from '../commercialVechiclePage/CommercialVehicleEmiSection';
import CommercialVehicleChooseUsSection from '../commercialVechiclePage/CommercialVehicleChooseUsSection';
import {useTranslation} from "react-i18next";
import usePageTitle from '../../hooks/usePageTitle';

const BusinessExpansionPage = () => {
    usePageTitle('page-title', 'businessExpansionPage');
    const heroRef = useRef(null);
    const handleClick = () => {
        heroRef.current?.scrollIntoView({behavior: 'smooth'});
    };
    const {t} =useTranslation('businessExpansionPage');
    const content= t('business-expansion-choose-us-section-description');
    const productType="Business Loan";
    return (
        <>
            <Header/>
            <BusinessExpansionHeroSection ref={heroRef} onScrollToForm={handleClick}/>
            <BusinessExpansionBusinessSection/>
            {/* <CommercialVehicleEmiSection ref={heroRef} productType={productType}/> */}
            <CommercialVehicleChooseUsSection content={content} onApplyNowClick={handleClick}/>
            <Footer/>
        </>
    );
}

export default BusinessExpansionPage;